import { PlusOutlined, UploadOutlined } from "@ant-design/icons";
import {
  Button,
  DatePicker,
  Form,
  Input,
  Modal,
  Select,
  Table,
  Upload,
} from "antd";
import { useEffect } from "react";
import { useAddOnService } from "./modules/useAddOnService";
import { getColumns } from "./modules/getColumns";
import moment from "moment";

const { Option } = Select;
const { RangePicker } = DatePicker;

const AddOnServiceTemplate = () => {
  const {
    fetchAddOnServices,
    addOnServices,
    loading,
    isModalVisible,
    editingService,
    fileList,
    form,
    handleFormSubmit,
    handleUploadChange,
    handleDelete,
    openModal,
    handleCancel,
  } = useAddOnService();

  const columns = getColumns(openModal, handleDelete);

  useEffect(() => {
    fetchAddOnServices();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="container">
      <h1>Manage Add-On Services</h1>
      <Button
        type="primary"
        icon={<PlusOutlined />}
        onClick={() => openModal()}
      >
        Create New Service
      </Button>
      <Table
        dataSource={addOnServices}
        columns={columns}
        rowKey="_id"
        loading={loading}
        className="mt-4"
        pagination={{ pageSize: 10 }}
        scroll={{ x: 1000 }}
      />

      <Modal
        title={editingService ? "Edit Service" : "Create Service"}
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={null}
      >
        <Form form={form} layout="vertical" onFinish={handleFormSubmit}>
          <Form.Item
            name="serviceName"
            label="Service Name"
            rules={[{ required: true }]}
          >
            <Input placeholder="Enter service name" />
          </Form.Item>

          <Form.Item
            name="kindOfService"
            label="Kind of Service"
            rules={[{ required: true }]}
          >
            <Select placeholder="Select kind of service">
              <Option value="Transportation">Transportation</Option>
              <Option value="Wellness">Wellness</Option>
              <Option value="F&B">F&B</Option>
              <Option value="Tour">Tour</Option>
              <Option value="Decoration">Decoration</Option>
              <Option value="Entertainment">Entertainment</Option>
              <Option value="Kid">Kid</Option>
            </Select>
          </Form.Item>

          <Form.Item
            name="chargeType"
            label="Charge Type"
            rules={[{ required: true }]}
          >
            <Select placeholder="Select charge type">
              <Option value="Per Booking">Per Booking</Option>
              <Option value="Per Pax">Per Pax</Option>
              <Option value="Per Stay">Per Stay</Option>
              <Option value="Per Night">Per Night</Option>
            </Select>
          </Form.Item>

          <Form.Item
            name="servicePrice"
            label="Service Price"
            rules={[{ required: true }]}
          >
            <Input type="number" placeholder="Enter service price" />
          </Form.Item>

          <Form.Item
            name="serviceDescription"
            label="Service Description"
            rules={[{ required: true }]}
          >
            <Input.TextArea rows={4} placeholder="Enter service description" />
          </Form.Item>

          <Form.Item
            name="dateApplied"
            label="Date Applied"
            rules={[{ required: true }]}
          >
            <RangePicker
              format="DD-MM-YYYY"
              disabledDate={(current) =>
                current && current < moment().startOf("day")
              }
            />
          </Form.Item>

          <Form.Item name="photo" label="Upload Photo">
            <Upload
              listType="picture"
              beforeUpload={() => false} // Disable auto upload
              onChange={handleUploadChange} // Handle file selection
              fileList={fileList}
            >
              <Button icon={<UploadOutlined />}>Click to Upload</Button>
            </Upload>
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" block>
              {editingService ? "Update Service" : "Create Service"}
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default AddOnServiceTemplate;
